
      import API from "!../../../node_modules/.pnpm/style-loader@3.3.3_webpack@5.89.0_webpack-cli@4.10.0_/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../../../node_modules/.pnpm/style-loader@3.3.3_webpack@5.89.0_webpack-cli@4.10.0_/node_modules/style-loader/dist/runtime/styleDomAPI.js";
      import insertFn from "!../../../node_modules/.pnpm/style-loader@3.3.3_webpack@5.89.0_webpack-cli@4.10.0_/node_modules/style-loader/dist/runtime/insertBySelector.js";
      import setAttributes from "!../../../node_modules/.pnpm/style-loader@3.3.3_webpack@5.89.0_webpack-cli@4.10.0_/node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js";
      import insertStyleElement from "!../../../node_modules/.pnpm/style-loader@3.3.3_webpack@5.89.0_webpack-cli@4.10.0_/node_modules/style-loader/dist/runtime/insertStyleElement.js";
      import styleTagTransformFn from "!../../../node_modules/.pnpm/style-loader@3.3.3_webpack@5.89.0_webpack-cli@4.10.0_/node_modules/style-loader/dist/runtime/styleTagTransform.js";
      import content, * as namedExport from "!!../../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0_webpack-cli@4.10.0_/node_modules/css-loader/dist/cjs.js!../../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.69.5_webpack@5.89.0_webpack-cli@4.10.0_/node_modules/sass-loader/dist/cjs.js!./sidebar.css";
      
      

var options = {};

options.styleTagTransform = styleTagTransformFn;
options.setAttributes = setAttributes;

      options.insert = insertFn.bind(null, "head");
    
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);



export * from "!!../../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0_webpack-cli@4.10.0_/node_modules/css-loader/dist/cjs.js!../../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.69.5_webpack@5.89.0_webpack-cli@4.10.0_/node_modules/sass-loader/dist/cjs.js!./sidebar.css";
       export default content && content.locals ? content.locals : undefined;
